export * from './lib/sync-or-async.pipe.module';
